// Current Terms of Service version. Bump this string whenever the ToS changes
// (e.g. to a new effective date); every user whose accepted `tos_version` no
// longer matches will be re-prompted with the clickwrap gate on next load.
//
// This is the single source of truth for the comparison. The backend faithfully
// stores whatever version the client submits on acceptance, so there is no
// separate server-side version to keep in sync.
export const CURRENT_TOS_VERSION = "2026-06-12";

// Whether the given accepted version satisfies the current ToS.
export function hasAcceptedCurrentTos(
  acceptedVersion: string | null | undefined,
): boolean {
  return acceptedVersion === CURRENT_TOS_VERSION;
}
